document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.menu-tab-nav-item a[href^="#"]').forEach((anchorLink) => {
    anchorLink.addEventListener('click', (event) => {
      const href = anchorLink.getAttribute('href');
      const targetId = href?.substring(1);
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();

      const rect = target.getBoundingClientRect();
      const scrollDirection = rect.top > 0 ? 'down' : 'up';

      //window.scrollBy(0, scrollDirection === 'down' ? 11 : -11);

      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    });
  });

  function toggleMenuItems(){
    setTimeout(() => { // We need to delay so other functions triggered by this event runs first
      document.querySelectorAll('.menu-tab-nav-item a[href^="#"]').forEach((anchor) => {
        const href = anchor.getAttribute('href');
        const targetId = href?.substring(1);
        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target) return;

        if (target.classList.contains('hidden!')) {
          anchor.closest('li').classList.add('hidden!');
        }else{
          anchor.closest('li').classList.remove('hidden!');
        }
      });
    }, 1);
  }

  toggleMenuItems();
  document.body.addEventListener('venueChanged', toggleMenuItems);
});
